import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class AerationBasinNodeModel extends Node {
  constructor(device = {}, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.AerationBasin,
    });
  }
}
